import { Icon } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from '../styles';
export default function OuterFooter(_ref) {
  let dataNavigation = _ref.dataNavigation,
    handleNavigation = _ref.handleNavigation;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.outerFooter
  }, dataNavigation && dataNavigation[0].prev && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "text",
    className: "".concat(classes.outerFooterControls, " ").concat(classes.prev),
    onClick: () => {
      handleNavigation(dataNavigation[0].prev);
    },
    'custom-attribute': '258-resident-modal-outer-footer'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-left"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('general.previous'), ": ", t('general.unit'), " ", dataNavigation[0].prev.unitName)), dataNavigation && dataNavigation[0].next && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "text",
    className: "".concat(classes.outerFooterControls, " ").concat(classes.next),
    onClick: () => {
      handleNavigation(dataNavigation[0].next);
    },
    'custom-attribute': '259-resident-modal-outer-footer'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('general.next'), ": ", t('general.unit'), " ", dataNavigation[0].next.unitName), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-right"
  })));
}